'use strict'

import { TweenLite } from 'gsap';
import st from './scrollto';

import listings from './listings'
import listingsPagination from './listings.pagination'

let self

export default self = {
  container    : document.getElementById('sortResults'),
  headerHeight : document.querySelector('header').clientHeight,

  init : () => {
    self.setupElements()
    self.registerEvents()
    self.onScroll()
  },

  setupElements : () => {
    self.scrollUp = document.querySelector('.scroll-up')
    self.filters = [...self.container.querySelectorAll('select')]
    self.listingsContainer = document.querySelector('.listings')
    self.map = document.getElementById('map')
  },

  registerEvents : () => {
    window.addEventListener('scroll', self.onScroll)
    self.scrollUp.addEventListener('click', self.scrollToTop)
    self.filters.forEach( filter => filter.addEventListener('change', self.onSortChange) )
  },

  scrollToTop : e => {
    const pickerHeight = listings.container.clientHeight
    const mapHeight = (self.map) ? self.map.clientHeight : 0
    const sortNavHeight = self.container.clientHeight
    const pos = pickerHeight + mapHeight - sortNavHeight

    return st.animate(pos, 500)
  },

  onScroll : e => {
    const shouldFixNav = (self.container.getBoundingClientRect().top - self.headerHeight) < 0 && !self.container.classList.contains('fixed')
    const shouldUnfixNav = (self.container.getBoundingClientRect().top - self.headerHeight) > 0 && self.container.classList.contains('fixed')

    if (shouldFixNav) self.container.classList.add('fixed')
    if (shouldUnfixNav) self.container.classList.remove('fixed')
  },

  onSortChange : e => {
    let sortedListings
    const select         = e.currentTarget
    const key            = self.getDataKey({ name : select.name })
    const dir            = select.options[select.selectedIndex].value
    //const listings       = [...self.listingsContainer.querySelectorAll('article')]
    const childNodes     = [...self.listingsContainer.childNodes]

    // Choose Sorting Function
    if ( select.name === 'days_on_market' ) {
      sortedListings = self.sortByDate({ key : key, dir : dir, listings : listings.listings })
    } else {
      sortedListings = self.sortByNumber({ key : key, dir : dir, listings : listings.listings })
    }

    // Reset Select Elements
    self.resetSelectElements({ ignoreName : select.name })

    // Disable pagination so it doesn't load any more while it sorts
    listingsPagination.disable()

    // Remove all child nodes
    childNodes.forEach( node => self.listingsContainer.removeChild(node) )

    // Scroll back to top
    self.scrollUp.click()

    // Append the sorted child nodes
    sortedListings.map( listing => self.listingsContainer.append(listing.el) )

    // Reenable pagination
    setTimeout( () => listingsPagination.enable(), 1000 )
  },

  getDataKey : ({ name }) => {
    switch (name) {
      case 'price':
        return 'price'
      break;
      case 'days_on_market':
        return 'list_date'
      break;
      case 'square_footage':
        return 'total_area'
      break;
      case 'bedrooms':
        return 'total_bedrooms'
      break;
    }
  },

  sortByNumber : ({ key, dir, listings }) => {
    listings.sort( (a,b) => {
      const aPrice = parseInt(a.acf[key])
      const bPrice = parseInt(b.acf[key])

      return aPrice - bPrice
    })

    if (dir === 'desc') listings.reverse()

    return listings
  },

  sortByDate : ({ key, dir, listings }) => {
    listings.sort( (a,b) => {
      const aa = a.acf[key].split('-').join()
      const bb = b.acf[key].split('-').join()

      return aa < bb ? -1 : (aa > bb ? 1 : 0)
    })

    if (dir === 'desc') listings.reverse()

    return listings
  },

  resetSelectElements : ({ ignoreName }) => {
    self.filters.forEach( filter => {
      if ( filter.name === ignoreName ) return false
      if ( filter.selectedIndex !== 0 ) filter.selectedIndex = 0
    })
  }
}
